/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiDefApiConfiguration } from '../api-def-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pricingCreatePricingPlan } from '../fn/pricing/pricing-create-pricing-plan';
import { PricingCreatePricingPlan$Params } from '../fn/pricing/pricing-create-pricing-plan';
import { pricingDeletePricingPlan } from '../fn/pricing/pricing-delete-pricing-plan';
import { PricingDeletePricingPlan$Params } from '../fn/pricing/pricing-delete-pricing-plan';
import { pricingGetPricingPlans } from '../fn/pricing/pricing-get-pricing-plans';
import { PricingGetPricingPlans$Params } from '../fn/pricing/pricing-get-pricing-plans';
import { ApiDefPricingInfo } from '../models/api-def-pricing-info';
import { pricingUpdatePricingPlan } from '../fn/pricing/pricing-update-pricing-plan';
import { PricingUpdatePricingPlan$Params } from '../fn/pricing/pricing-update-pricing-plan';


/**
 * Operations related to pricing plans and billing
 */
@Injectable({ providedIn: 'root' })
export class PricingService extends BaseService {
  constructor(config: ApiDefApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pricingGetPricingPlans()` */
  static readonly PricingGetPricingPlansPath = '/pricingPlans';

  /**
   * List available pricing plans.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricingGetPricingPlans()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricingGetPricingPlans$Response(params?: PricingGetPricingPlans$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'pricingInfo'?: ApiDefPricingInfo;
}>> {
    return pricingGetPricingPlans(this.http, this.rootUrl, params, context);
  }

  /**
   * List available pricing plans.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricingGetPricingPlans$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pricingGetPricingPlans(params?: PricingGetPricingPlans$Params, context?: HttpContext): Observable<{
'pricingInfo'?: ApiDefPricingInfo;
}> {
    return this.pricingGetPricingPlans$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'pricingInfo'?: ApiDefPricingInfo;
}>): {
'pricingInfo'?: ApiDefPricingInfo;
} => r.body)
    );
  }

  /** Path part for operation `pricingCreatePricingPlan()` */
  static readonly PricingCreatePricingPlanPath = '/pricingPlans';

  /**
   * Create pricing plan info.
   *
   * Create a new pricing plan with the specified data. This operation requires admin privileges.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricingCreatePricingPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingCreatePricingPlan$Response(params: PricingCreatePricingPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefPricingInfo>> {
    return pricingCreatePricingPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Create pricing plan info.
   *
   * Create a new pricing plan with the specified data. This operation requires admin privileges.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricingCreatePricingPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingCreatePricingPlan(params: PricingCreatePricingPlan$Params, context?: HttpContext): Observable<ApiDefPricingInfo> {
    return this.pricingCreatePricingPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefPricingInfo>): ApiDefPricingInfo => r.body)
    );
  }

  /** Path part for operation `pricingDeletePricingPlan()` */
  static readonly PricingDeletePricingPlanPath = '/pricingPlans';

  /**
   * Delete pricing plan info.
   *
   * Delete a pricing plan by its ID. This operation requires admin privileges.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricingDeletePricingPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingDeletePricingPlan$Response(params: PricingDeletePricingPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pricingDeletePricingPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete pricing plan info.
   *
   * Delete a pricing plan by its ID. This operation requires admin privileges.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricingDeletePricingPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingDeletePricingPlan(params: PricingDeletePricingPlan$Params, context?: HttpContext): Observable<void> {
    return this.pricingDeletePricingPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pricingUpdatePricingPlan()` */
  static readonly PricingUpdatePricingPlanPath = '/pricingPlans';

  /**
   * Update pricing plan info.
   *
   * Update an existing pricing plan with the specified data. This operation requires admin privileges.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pricingUpdatePricingPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingUpdatePricingPlan$Response(params: PricingUpdatePricingPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefPricingInfo>> {
    return pricingUpdatePricingPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Update pricing plan info.
   *
   * Update an existing pricing plan with the specified data. This operation requires admin privileges.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pricingUpdatePricingPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pricingUpdatePricingPlan(params: PricingUpdatePricingPlan$Params, context?: HttpContext): Observable<ApiDefPricingInfo> {
    return this.pricingUpdatePricingPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefPricingInfo>): ApiDefPricingInfo => r.body)
    );
  }

}
